module.exports = __webpack_public_path__ + "static/media/who-we-are.252c7f2e.png";